/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage (data){
            return http.json({
                url: `/sys/account/aftersale/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryBeforeAndAfterAccount (data){
            return http.json({
                url: `/sys/account/aftersale/queryBeforeAndAfterAccount?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },


        queryAllAccout (data){
            return http.json({
                url: `/sys/account/aftersale/queryAllAccout?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },


        queryByReceive(data) {
            return http.json({
                url: `/sys/account/aftersale/queryByReceive?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        getInfo (data){
            return http.json({
                url: `/sys/account/aftersale/get?id=${data.id}`,
                data
            })
        },
        queryUserList(data){
            return http.json({
                url: `/sys/account/aftersale/queryAll`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/sys/account/aftersale/saveAndAccredit`,
                data
            })
        },

        saveUser (data){
            return http.json({
                url: `/sys/account/aftersale/saveUser`,
                data
            })
        },
        toggleState(data){
            return http.json({
                url: `/sys/account/aftersale/toggleState`,
                data
            })
        },
        disable(data){
            return http.json({
                url: `/sys/account/aftersale/disable`,
                data
            })
        },
        recover(data){
            return http.json({
                url: `/sys/account/aftersale/recover`,
                data
            })
        },
        saveJxs (data){
            return http.json({
                url: `/sys/account/aftersale/saveAndAccreditJxs`,
                data
            })
        },

        saveAndAccreditShJxs (data){
            return http.json({
                url: `/sys/account/aftersale/saveAndAccreditShJxs`,
                data
            })
        },



        saveOther (data){
            return http.json({
                url: `/sys/account/aftersale/saveOther`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/sys/account/aftersale/delete`,
                data
            })
        },
        /**
         * 修改用户密码
         * @param data
         */
        modifyPassword (data){
            return http.json({
                url: '/sys/account/aftersale/modifyPassword',
                data
            });
        },


        saveAccountAndWarrantyCard(data) {
            return http.json({
                url: `/erp/warranty/card/saveAccountAndWarrantyCard`,
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/personalAftersale.js